var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var hotelActualSchema = 4;
        window.watchHotels = {
            getFromStorage: function getFromStorage() {
                var currentHash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var viewsStr = localStorage.getItem('tourViews');
                var views = {};
                if (viewsStr) {
                    views = JSON.parse(viewsStr);
                }
                // Сортируем туры в views по дате просмотра (по убыванию)
                var sortedViews = Object.entries(views).filter(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        _ = _ref2[0],
                        item = _ref2[1];

                    return item.data.version === hotelActualSchema;
                }).sort(function (_ref3, _ref4) {
                    var _ref6 = _slicedToArray(_ref3, 2),
                        a = _ref6[1];

                    var _ref5 = _slicedToArray(_ref4, 2),
                        b = _ref5[1];

                    return b.viewedAt - a.viewedAt;
                });
                // Ограничиваем количество туров до 100
                if (sortedViews.length > 100) {
                    sortedViews = sortedViews.slice(0, 100);
                }
                if (currentHash !== null) {
                    sortedViews = sortedViews.filter(function (_ref7) {
                        var _ref8 = _slicedToArray(_ref7, 2),
                            hash = _ref8[0],
                            _ = _ref8[1];

                        return hash !== currentHash;
                    });
                }
                return sortedViews;
            },

            /**
             * @param tourData
             */
            saveTourView: function saveTourView(tourData) {
                var list = this.getFromStorage(tourData.hash);
                // Добавляем тур в начало истории
                var currentTime = new Date().getTime(); // Текущее время в миллисекундах
                list.unshift([tourData.hash, {
                    data: tourData,
                    viewedAt: currentTime
                }]);
                var views = {};
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _ref9 = _step.value;

                        var _ref10 = _slicedToArray(_ref9, 2);

                        var tourHash = _ref10[0];
                        var value = _ref10[1];

                        views[tourHash] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                localStorage.setItem('tourViews', JSON.stringify(views));
                console.log('Save Viewed Hotels', views, tourData);
            },
            getLastTours: function getLastTours() {
                var currentHash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

                // Преобразуем объект в массив, берем первые 10 элементов и возвращаем их данные
                var tours = this.getFromStorage(currentHash);
                tours = tours.slice(0, count)
                // Возвращаем только данные туров
                .map(function (_ref11) {
                    var _ref12 = _slicedToArray(_ref11, 2),
                        _ = _ref12[0],
                        tour = _ref12[1];

                    return tour.data;
                });
                console.log('getLastTours', tours);
                return tours;
            },
            renderViewedTours: function renderViewedTours(wrapperSelector) {
                var currentTourHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                var tours = window.watchHotels.getLastTours(currentTourHash);
                console.log('renderViewedTours', currentTourHash, tours);
                var swiperContainer = document.getElementById('watched-hotels-container');
                if (!swiperContainer) {
                    return;
                }
                var swiperWrapper = document.getElementById('watched-hotels-wrapper');
                // Очищаем содержимое контейнера на случай повторного вызова функции
                swiperWrapper.innerHTML = '';
                if (tours.length === 0) {
                    swiperContainer.classList.add('hide');
                    return;
                }
                // Если туры есть, показываем Swiper
                swiperContainer.classList.remove('hide');
                document.getElementById('watch-hotels__content').classList.remove('hide');
                document.getElementById('watch-hotels__header').classList.remove('hide');

                // Создаем слайды для каждого тура
                tours.forEach(function (tour) {
                    var slide = document.createElement('div');
                    slide.className = 'swiper-slide';

                    // Формируем URL на основе данных тура
                    // todo ссылка в зависимости от даты просмотра тура
                    var tourUrl = "/reservation/" + tour.tourId + "?from=watched_tours";

                    var isActual = true;
                    var viewDate = new Date(tour.viewDate);
                    var currentDate = new Date();
                    var minutesPassed = (currentDate - viewDate) / 60000; // Разница в минутах
                    if (minutesPassed > 30) {
                        isActual = false;
                        var baseUrl = "/new/hotel/" + tour.countryAlias + "/" + tour.regionAlias + "/" + tour.hotelAlias;
                        var url = new URL(baseUrl, window.location.origin);

                        // Создаем объект URLSearchParams для управления параметрами
                        var _params = new URLSearchParams({
                            search: 1,
                            tour: tour.tourId,
                            adult: tour.adult,
                            child: tour.child,
                            // Объединяем возраста детей в одну строку через запятую
                            childAges: tour.childAges.join(','),
                            departCity: tour.departCityId,
                            country: tour.countryId,
                            hotels: tour.hotelId,
                            dateFrom: tour.dateFrom,
                            dateTo: tour.dateFrom,
                            delta: 0,
                            nightsFrom: tour.totalNights,
                            nightsTo: tour.totalNights,
                            from: 'watched_tours'
                        });

                        // Присоединяем параметры к URL
                        url.search = _params.toString();
                        tourUrl = url.toString();
                    }

                    var peoples = tour.adult + " \u0432\u0437\u0440";
                    if (tour.child) {
                        peoples += ", " + tour.child + " \u0440\u0435\u0431 (" + tour.childAges.join(', ') + ")";
                    }
                    var days = tour.days + " \u0434\u043D\u0435\u0439";
                    if (tour.nightsOnWay) {
                        days += " (" + tour.nightsOnWay + " \u043D\u043E\u0447\u0435\u0439 \u0432 \u043F\u0443\u0442\u0438)";
                    }

                    var items = [tour.countryName + " c " + tour.dateFromStr + " \u043D\u0430 " + days, tour.meal, tour.room];
                    if (tour.airline) {
                        items.push(tour.airline);
                    }
                    items.push(peoples);
                    var tourInfo = items.join(', ') + '<br>';
                    if (isActual) {
                        tourInfo += "<span class=\"tour-price\">" + tour.price + "</span>";
                    } else {
                        tourInfo += '<span class="tour-price">Уточнить цену</span>';
                    }

                    slide.innerHTML = "\n      <a href=\"" + tourUrl + "\"\n         class=\"tour-card-link send-analytic-event\"\n         target=\"_blank\"\n         data-event=\"watched-tour-click\">\n        <div class=\"tour-card\">\n          <div class=\"tour-image\" style=\"background-image: url('" + tour.photo + "');\"></div>\n          <div class=\"tour-info\">\n            <div class=\"tour-header\">\n              <div class=\"tour-name\">" + tour.hotelName + "</div>\n            </div>\n            <div class=\"tour-subtitle\"></div>\n            <div class=\"tour-details\">\n               " + tourInfo + "\n            </div>\n          </div>\n        </div>\n      </a>  \n    ";

                    swiperWrapper.appendChild(slide);
                });

                var slidesPerView = +swiperContainer.dataset.slidesperview;

                if (!slidesPerView) {
                    slidesPerView = 1.2;
                }

                var params = {
                    slidesPerView: slidesPerView,
                    spaceBetween: 15
                };

                var prev = document.querySelector('.prev-watched-hotels');
                var next = document.querySelector('.next-watched-hotels');

                if (next && prev) {
                    params.navigation = {
                        nextEl: '.next-watched-hotels',
                        prevEl: '.prev-watched-hotels'
                    };
                }
                new Swiper('#watched-hotels-container', params);
            }
        };
    }, {}] }, {}, [1]);